import { ajax } from 'rxjs/ajax';

export const getRouteList = () => {
    return ajax({
        method: 'GET',
        url: `${process.env.CMFA_APP_PLATFORM_ORDER_CAPTOR_URL}/routes`,
        crossDomain: true,
    });
};
